import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toTitleCase } from "@/lib/titleCase";

export interface ServiceAddon {
  id: string;
  category_id: string;
  name: string;
  duration: string;
  price: number;
  sort_order: number;
}

export const useServiceAddons = (categoryId?: string) => {
  const [addons, setAddons] = useState<ServiceAddon[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchAddons = useCallback(async () => {
    if (!categoryId) {
      setAddons([]);
      return;
    }
    setLoading(true);
    const { data, error } = await supabase
      .from("service_addons")
      .select("*")
      .eq("category_id", categoryId)
      .order("sort_order");
    if (error) {
      console.error("Error fetching addons:", error);
      setAddons([]);
    } else {
      setAddons((data || []).map((a) => ({
        id: a.id,
        category_id: a.category_id,
        name: toTitleCase(a.name),
        duration: a.duration,
        price: a.price,
        sort_order: a.sort_order,
      })));
    }
    setLoading(false);
  }, [categoryId]);

  useEffect(() => {
    fetchAddons();
  }, [fetchAddons]);

  return { addons, loading, refetch: fetchAddons };
};
